import { ADD_PLAYERS } from "../constants/playerConstants.js";

export const addPlayers = players => ({
  type: ADD_PLAYERS,
  payload: players
});
